import React, { useEffect, useRef, useState } from "react";

// Crossfading banner with Ken Burns zoom.
// images: array of urls. interval default 1000ms per spec.
const CrossfadeBanner = ({ images, interval = 1000, children, className = "" }) => {
  const [idx, setIdx] = useState(0);
  const ref = useRef(null);
  const visibleRef = useRef(true);

  useEffect(() => {
    if (!ref.current) return;
    const obs = new IntersectionObserver(
      (entries) => {
        visibleRef.current = entries[0].isIntersecting;
      },
      { threshold: 0.1 }
    );
    obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  useEffect(() => {
    const id = setInterval(() => {
      if (!visibleRef.current) return;
      setIdx((i) => (i + 1) % images.length);
    }, interval);
    return () => clearInterval(id);
  }, [images, interval]);

  return (
    <div
      ref={ref}
      className={`relative overflow-hidden rounded-[20px] shadow-card ${className}`}
      style={{ minHeight: "320px" }}
    >
      {images.map((src, i) => (
        <div
          key={src}
          className="absolute inset-0 transition-opacity duration-1000"
          style={{ opacity: i === idx ? 1 : 0 }}
        >
          <img
            src={src}
            alt=""
            className="w-full h-full object-cover kenburns"
            draggable={false}
            loading="lazy"
          />
        </div>
      ))}
      <div className="absolute inset-0 bg-gradient-to-t from-ink/70 via-ink/0 to-ink/20" />
      {children}
    </div>
  );
};

export default CrossfadeBanner;
